export default __webpack_public_path__ + "static/media/blockchain.8fb11ab4.png";